
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "../images/logo.png";
import { useCategories } from "../context/CategoriesContext";
import { useCart } from "../context/CartContext";
import { isAuthenticated } from "../utils/auth";
import { useNavigate } from "react-router-dom";
import { fetchProductsByCategory, fetchAccessoriesTypes, fetchOnSaleTypes } from "../api/productApi";
import { isAdmin } from "../utils/auth";
import TopBar from "./TopBar";
import { useWishlist } from "../context/WishlistContext";

export default function Navbar() {
  const [activeMain, setActiveMain] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { totalItems } = useCart();
  const { wishlistItems } = useWishlist();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const navigate = useNavigate();

  // Listen for login modal open events (e.g., from product detail page)
  useEffect(() => {
    const handleOpenLoginModal = () => {
      setIsAuthModalOpen(true);
    };

    window.addEventListener('openLoginModal', handleOpenLoginModal);
    return () => {
      window.removeEventListener('openLoginModal', handleOpenLoginModal);
    };
  }, []);

  // Listen for openWomenMenu event (e.g., from landing page)
  useEffect(() => {
    const handleOpenWomenMenu = () => {
      navigate("/women");
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    };

    window.addEventListener('openWomenMenu', handleOpenWomenMenu);
    return () => {
      window.removeEventListener('openWomenMenu', handleOpenWomenMenu);
    };
  }, [navigate]);

  // Listen for openAccessoriesMenu event (e.g., from landing page)
  useEffect(() => {
    const handleOpenAccessoriesMenu = () => {
      navigate("/accessories");
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    };

    window.addEventListener('openAccessoriesMenu', handleOpenAccessoriesMenu);
    return () => {
      window.removeEventListener('openAccessoriesMenu', handleOpenAccessoriesMenu);
    };
  }, [navigate]);

  // Listen for openOnSaleMenu event (e.g., from landing page)
  useEffect(() => {
    const handleOpenOnSaleMenu = () => {
      navigate("/sale");
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    };

    window.addEventListener('openOnSaleMenu', handleOpenOnSaleMenu);
    return () => {
      window.removeEventListener('openOnSaleMenu', handleOpenOnSaleMenu);
    };
  }, [navigate]);

  // Listen for openMenMenu event (e.g., from landing page)
  useEffect(() => {
    const handleOpenMenMenu = () => {
      navigate("/men");
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    };

    window.addEventListener('openMenMenu', handleOpenMenMenu);
    return () => {
      window.removeEventListener('openMenMenu', handleOpenMenMenu);
    };
  }, [navigate]);

  const { categories, loading, error } = useCategories();
  const [searchQuery, setSearchQuery] = useState("");
  const [accessoriesTypes, setAccessoriesTypes] = useState([]);
  const [loadingAccessories, setLoadingAccessories] = useState(false);
  const [onSaleTypes, setOnSaleTypes] = useState([]);
  const [loadingOnSale, setLoadingOnSale] = useState(false);

  // Fetch accessories types on mount
  useEffect(() => {
    const loadAccessoriesTypes = async () => {
      setLoadingAccessories(true);
      try {
        const types = await fetchAccessoriesTypes();
        setAccessoriesTypes(types);
      } catch (err) {
        console.error("Failed to load accessories types", err);
        setAccessoriesTypes([]);
      } finally {
        setLoadingAccessories(false);
      }
    };
    loadAccessoriesTypes();
  }, []);

  // Fetch on sale types on mount
  useEffect(() => {
    const loadOnSaleTypes = async () => {
      setLoadingOnSale(true);
      try {
        const types = await fetchOnSaleTypes();
        setOnSaleTypes(types);
      } catch (err) {
        console.error("Failed to load on sale types", err);
        setOnSaleTypes([]);
      } finally {
        setLoadingOnSale(false);
      }
    };
    loadOnSaleTypes();
  }, []);

  useEffect(() => {
   
  }, [categories, loading, error]);

  const allCategories = (() => {
    if (!categories) {
      return [];
    }

    if (Array.isArray(categories)) {
      const filtered = categories.filter((cat) => {
        const isValid =
          cat &&
          typeof cat === "object" &&
          cat.category &&
          typeof cat.category === "string" &&
          Array.isArray(cat.subcategories);

        if (!isValid) {
          // console.log("Invalid category:", {
          //   cat,
          //   hasCategory: !!(cat && cat.category),
          //   categoryType: typeof cat?.category,
          //   hasSubcategories: !!(cat && cat.subcategories),
          //   subcategoriesIsArray: Array.isArray(cat?.subcategories),
          // });
        }
        return isValid;
      });

      return filtered;
    }

    return [];
  })();

  const handleWomenClick = () => {
    navigate("/women");
    setActiveMain(null);
    setActiveCategory(null);
    setIsMenuOpen(false);
  };

  const handleMenClick = () => {
    navigate("/men");
    setActiveMain(null);
    setActiveCategory(null);
    setIsMenuOpen(false);
  };

  const handleAccessoriesClick = () => {
    navigate("/accessories");
    setActiveMain(null);
    setActiveCategory(null);
    setIsMenuOpen(false);
  };

  const handleOnSaleClick = () => {
    navigate("/sale");
    setActiveMain(null);
    setActiveCategory(null);
    setIsMenuOpen(false);
  };

  const handleCategoryClick = (cat) => {
    // console.log("Category clicked:", cat);
    if (activeCategory?.category === cat.category) {
      setActiveCategory(null);
    } else {
      setActiveCategory(cat);
    }
  };

  const closeDrawer = () => {
    setIsMenuOpen(false);
    setActiveMain(null);
    setActiveCategory(null);
  };

  const handleUserClick = () => {
    if (!isAuthenticated()) {
      setIsAuthModalOpen(true);
    } else if (isAdmin()) {
      navigate("/admin");
    } else {
      navigate("/account");
    }
  };

  // Listen for closeAuthModal event (dispatched from signOut)
  useEffect(() => {
    const handleCloseAuthModal = () => {
      setIsAuthModalOpen(false);
    };

    window.addEventListener("closeAuthModal", handleCloseAuthModal);
    return () => {
      window.removeEventListener("closeAuthModal", handleCloseAuthModal);
    };
  }, []);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;
    navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
  };

  const handleSubcategoryClick = async (category, subcategory) => {
    try {
      const products = await fetchProductsByCategory(category, subcategory);
      navigate("/products", {
        state: {
          products,
          category,
          subcategory,
        },
      });
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    } catch (err) {
      console.error("Failed to load products", err);
      alert("Could not load products. Please try again.");
    }
  };

  const handleAccessoryTypeClick = async (productTypeName) => {
    try {
      const products = await fetchProductsByCategory("Accessories", productTypeName);
      navigate("/products", {
        state: {
          products,
          category: "Accessories",
          subcategory: productTypeName,
        },
      });
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    } catch (err) {
      console.error("Failed to load accessories products", err);
      alert("Could not load products. Please try again.");
    }
  };

  const handleOnSaleTypeClick = async (productTypeName, productGroupName) => {
    try {
      // Use product_group_name if available, otherwise fallback to "On Sale"
      const category = productGroupName || "On Sale";
      const products = await fetchProductsByCategory(category, productTypeName);
      navigate("/products", {
        state: {
          products,
          category: category,
          subcategory: productTypeName,
        },
      });
      setActiveMain(null);
      setActiveCategory(null);
      setIsMenuOpen(false);
    } catch (err) {
      console.error("Failed to load on sale products", err);
      alert("Could not load products. Please try again.");
    }
  };

  if (loading) {
    return (
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="flex items-center">
                <img
                  src={Logo}
                  alt="JKTech"
                  className="h-12 w-auto object-contain"
                />
              </Link>
            </div>
            <div className="text-gray-500">Loading...</div>
          </div>
        </div>
      </nav>
    );
  }

  if (error) {
    console.error("Categories error:", error);
  }

  return (
    <>
      {/* Main Navbar */}
      <nav className="navbar">
        <TopBar
          activeMain={activeMain}
          onWomenClick={handleWomenClick}
          onMenClick={handleMenClick}
          onAccessoriesClick={handleAccessoriesClick}
          onOnSaleClick={handleOnSaleClick}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          onSearchSubmit={handleSearchSubmit}
          onUserClick={handleUserClick}
          isAuthModalOpen={isAuthModalOpen}
          onCloseAuthModal={() => setIsAuthModalOpen(false)}
          totalItems={totalItems}
          wishlistItems={wishlistItems?.length || 0}
          onOpenMenu={() => setIsMenuOpen(true)}
        />

        {/* Desktop Dropdown */}
        {activeMain === "WOMEN" && (
          <div className="dropdown-overlay">
            <div
              className="dropdown-backdrop"
              onClick={() => setActiveMain(null)}
            />
            <div className="dropdown-panel">
              <div className="dropdown-header">
                <h2 className="dropdown-title">SHOP WOMEN</h2>
                <button
                  onClick={() => setActiveMain(null)}
                  className="dropdown-close-btn"
                >
                  ✕
                </button>
              </div>
              <nav className="dropdown-nav">
                {allCategories.length === 0 ? (
                  <div className="dropdown-no-data">
                    No categories available
                  </div>
                ) : (
                  allCategories.map((cat) => (
                    <div key={cat.category} className="space-y-1">
                      <button
                        type="button"
                        onClick={() => handleCategoryClick(cat)}
                        className={`dropdown-category-btn ${
                          activeCategory?.category === cat.category
                            ? "active"
                            : "inactive"
                        }`}
                      >
                        <span className="flex items-center gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 6h16M4 12h16M4 18h16"
                            />
                          </svg>
                          {cat.category}
                        </span>
                        <span className="text-xs text-gray-400">
                          ({cat.subcategories ? cat.subcategories.length : 0})
                        </span>
                      </button>

                      {activeCategory?.category === cat.category && (
                        <div className="dropdown-subcategory-list">
                          {!cat.subcategories ||
                          !Array.isArray(cat.subcategories) ? (
                            <div className="mobile-no-data">
                              No subcategories
                            </div>
                          ) : cat.subcategories.length === 0 ? (
                            <div className="mobile-no-data">
                              No subcategories available
                            </div>
                          ) : (
                            cat.subcategories
                              .filter(
                                (sub) =>
                                  sub &&
                                  typeof sub === "string" &&
                                  sub.trim() !== "" &&
                                  sub !== "Unknown"
                              )
                              .map((sub) => (
                                <button
                                  key={`${cat.category}-${sub}`}
                                  type="button"
                                  onClick={() =>
                                    handleSubcategoryClick(cat.category, sub)
                                  }
                                  className="dropdown-subcategory-btn"
                                >
                                  {sub}
                                </button>
                              ))
                          )}
                        </div>
                      )}
                    </div>
                  ))
                )}
              </nav>
            </div>
          </div>
        )}

        {/* Accessories Dropdown */}
        {activeMain === "ACCESSORIES" && (
          <div className="dropdown-overlay">
            <div
              className="dropdown-backdrop"
              onClick={() => setActiveMain(null)}
            />
            <div className="dropdown-panel">
              <div className="dropdown-header">
                <h2 className="dropdown-title">SHOP ACCESSORIES</h2>
                <button
                  onClick={() => setActiveMain(null)}
                  className="dropdown-close-btn"
                >
                  ✕
                </button>
              </div>
              <nav className="dropdown-nav">
                {loadingAccessories ? (
                  <div className="dropdown-no-data">Loading accessories...</div>
                ) : accessoriesTypes.length === 0 ? (
                  <div className="dropdown-no-data">
                    No accessories available
                  </div>
                ) : (
                  <div className="space-y-1">
                    {accessoriesTypes.map((type) => (
                      <button
                        key={type.product_type_name}
                        type="button"
                        onClick={() => handleAccessoryTypeClick(type.product_type_name)}
                        className="dropdown-subcategory-btn"
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                      >
                        <span>{type.product_type_name}</span>
                        <span className="text-xs text-gray-400">
                          ({type.product_count})
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </nav>
            </div>
          </div>
        )}

        {/* On Sale Dropdown */}
        {activeMain === "ONSALE" && (
          <div className="dropdown-overlay">
            <div
              className="dropdown-backdrop"
              onClick={() => setActiveMain(null)}
            />
            <div className="dropdown-panel">
              <div className="dropdown-header">
                <h2 className="dropdown-title">ON SALE</h2>
                <button
                  onClick={() => setActiveMain(null)}
                  className="dropdown-close-btn"
                >
                  ✕
                </button>
              </div>
              <nav className="dropdown-nav">
                {loadingOnSale ? (
                  <div className="dropdown-no-data">Loading on sale items...</div>
                ) : onSaleTypes.length === 0 ? (
                  <div className="dropdown-no-data">
                    No on sale items available
                  </div>
                ) : (
                  <div className="space-y-1">
                    {onSaleTypes.map((type) => (
                      <button
                        key={type.product_type_name}
                        type="button"
                        onClick={() => handleOnSaleTypeClick(type.product_type_name, type.product_group_name)}
                        className="dropdown-subcategory-btn"
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                      >
                        <span>{type.product_type_name}</span>
                        <span className="text-xs text-gray-400">
                          ({type.product_count})
                        </span>
                      </button>
                    ))}
                  </div>
                )}
              </nav>
            </div>
          </div>
        )}
      </nav>

      {/* Mobile Side Drawer */}
      {isMenuOpen && (
        <div className="mobile-drawer-overlay">
          <div className="mobile-drawer-backdrop" onClick={closeDrawer} />
          <div className="mobile-drawer-panel">
            <div className="mobile-drawer-header">
              <h2 className="mobile-drawer-title">Menu</h2>
              <button onClick={closeDrawer} className="mobile-drawer-close-btn">
                ✕
              </button>
            </div>
            <nav className="mobile-drawer-nav">
              <div>
                <button
                  type="button"
                  onClick={handleWomenClick}
                  className={`mobile-main-link ${
                    activeMain === "WOMEN" ? "active" : "inactive"
                  }`}
                >
                  WOMEN ({allCategories.length})
                </button>
                <button
                  type="button"
                  onClick={handleMenClick}
                  className={`mobile-main-link ${
                    activeMain === "MEN" ? "active" : "inactive"
                  }`}
                >
                  MEN
                </button>

                {activeMain === "WOMEN" && (
                  <div className="mobile-subnav">
                    {activeCategory ? (
                      <>
                        <div className="flex items-center justify-between">
                          <h3 className="font-medium text-gray-700">
                            {activeCategory.category}
                          </h3>
                          <button
                            onClick={() => setActiveCategory(null)}
                            className="mobile-back-btn"
                          >
                            ← Back
                          </button>
                        </div>
                        {Array.isArray(activeCategory.subcategories) &&
                        activeCategory.subcategories.length > 0 ? (
                          <ul className="mobile-subcategory-list">
                            {activeCategory.subcategories
                              .filter(
                                (sub) =>
                                  sub &&
                                  typeof sub === "string" &&
                                  sub.trim() !== "" &&
                                  sub !== "Unknown"
                              )
                              .map((sub) => (
                                <li key={`${activeCategory.category}-${sub}`}>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleSubcategoryClick(
                                        activeCategory.category,
                                        sub
                                      )
                                    }
                                    className="mobile-subcategory-item-btn"
                                  >
                                    {sub}
                                  </button>
                                </li>
                              ))}
                          </ul>
                        ) : (
                          <div className="mobile-no-data">
                            No subcategories available
                          </div>
                        )}
                      </>
                    ) : (
                      <ul className="mobile-subcategory-list">
                        {allCategories.length === 0 ? (
                          <li className="mobile-no-data">
                            No categories available
                          </li>
                        ) : (
                          allCategories.map((cat) => (
                            <li key={cat.category}>
                              <button
                                onClick={() => handleCategoryClick(cat)}
                                className="mobile-subcategory-item-btn"
                              >
                                {cat.category} (
                                {Array.isArray(cat.subcategories)
                                  ? cat.subcategories.length
                                  : 0}
                                )
                              </button>
                            </li>
                          ))
                        )}
                      </ul>
                    )}
                  </div>
                )}

                {/* Accessories in Mobile Menu */}
                <button
                  type="button"
                  onClick={handleAccessoriesClick}
                  className={`mobile-main-link ${
                    activeMain === "ACCESSORIES" ? "active" : "inactive"
                  }`}
                >
                  ACCESSORIES ({accessoriesTypes.length})
                </button>

                {activeMain === "ACCESSORIES" && (
                  <div className="mobile-subnav">
                    {loadingAccessories ? (
                      <div className="mobile-no-data">Loading accessories...</div>
                    ) : accessoriesTypes.length === 0 ? (
                      <div className="mobile-no-data">
                        No accessories available
                      </div>
                    ) : (
                      <ul className="mobile-subcategory-list">
                        {accessoriesTypes.map((type) => (
                          <li key={type.product_type_name}>
                            <button
                              type="button"
                              onClick={() => handleAccessoryTypeClick(type.product_type_name)}
                              className="mobile-subcategory-item-btn"
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                            >
                              <span>{type.product_type_name}</span>
                              <span className="text-xs text-gray-400">
                                ({type.product_count})
                              </span>
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                {/* On Sale in Mobile Menu */}
                <button
                  type="button"
                  onClick={handleOnSaleClick}
                  className={`mobile-main-link ${
                    activeMain === "ONSALE" ? "active" : "inactive"
                  }`}
                >
                  ON SALE ({onSaleTypes.length})
                </button>

                {activeMain === "ONSALE" && (
                  <div className="mobile-subnav">
                    {loadingOnSale ? (
                      <div className="mobile-no-data">Loading on sale items...</div>
                    ) : onSaleTypes.length === 0 ? (
                      <div className="mobile-no-data">
                        No on sale items available
                      </div>
                    ) : (
                      <ul className="mobile-subcategory-list">
                        {onSaleTypes.map((type) => (
                          <li key={type.product_type_name}>
                            <button
                              type="button"
                              onClick={() => handleOnSaleTypeClick(type.product_type_name, type.product_group_name)}
                              className="mobile-subcategory-item-btn"
                              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}
                            >
                              <span>{type.product_type_name}</span>
                              <span className="text-xs text-gray-400">
                                ({type.product_count})
                              </span>
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </div>
            </nav>
          </div>
        </div>
      )}
    </>
  );
}
